module.exports = __webpack_public_path__ + "static/media/8.1902109d.jpg";